import { NormalizedSchema, schema } from "normalizr";
import * as _ from "lodash";

import { FavouriteChartEntity, FavouritesList, FavouritesPayload } from "./typings";
import { DataDescriptorEntity } from "../data-dictionary";

/**
 * Combine display filters into a single "series" filter
 * @param {FavouritesPayload[number]["displayFilters"]} displayFilters
 * @returns {FavouriteChartEntity["displayFilters"]}
 */
export const reduceDisplayFilters = (
  displayFilters: FavouritesPayload[number]["displayFilters"]
): FavouriteChartEntity["displayFilters"] => {
  // @ts-ignore - type can be "series", but it's not in the typings
  return _.compact([
    // @ts-ignore - type can be "series", but it's not in the typings
    _.some(displayFilters, ({ type }) => type !== "series")
      ? _.reduce(
          displayFilters,
          (acc, { type, values }) => {
            acc.values = _.compact(_.uniq([...acc.values, ...values]));

            return acc;
          },
          {
            type: "series",
            values: [] as (string | number)[]
          }
        )
      : void 0
  ]);
};

/**
 * Favourite chart entity
 */
const charts = new schema.Entity(
  "charts",
  {},
  {
    idAttribute: ({ descriptorId }) => descriptorId,
    processStrategy: ({
      descriptorId,
      chartType,
      dateRange,
      displayFilters
    }: FavouritesPayload[number]): FavouriteChartEntity => {
      return {
        dataDescriptorID: descriptorId,
        view: _.camelCase(chartType),
        dateRange,
        displayFilters: reduceDisplayFilters(displayFilters)
      };
    }
  }
);

const page = [charts];

const favouritesList = new schema.Values(page);

export type NormalizedFavouritesList = NormalizedSchema<
  { charts: FavouritesList },
  Array<DataDescriptorEntity["id"]>
>;

export default {
  favouritesList
};
